:host {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: subgrid;
	box-sizing: border-box;
	box-shadow: 0px 1px 1px -1px rgb(var(--smoothly-table-border));
}

:host .smoothly-table-cell,
:host::slotted(.smoothly-table-cell) {
	display: flex;
	grid-column: span var(--smoothly-table-cell-span, 1);
	align-items: center;
	padding-inline: var(--smoothly-table-cell-padding-inline, 1.1rem);
	min-height: var(--smoothly-table-cell-min-height, 2.75rem);
	white-space: nowrap;
}

:host:has(smoothly-table-expandable-cell) {
	grid-template-rows: auto 0fr 0fr;
}

:host:has(smoothly-table-expandable-cell[open]) {
	grid-template-rows: auto 1fr 0fr;
}

